import React from 'react';
import { Modal, Switch } from 'antd';
import { ColumnProps } from 'antd/lib/table';

import { RemoteAccessOverlayNetwork } from '@totem/components/ticketing/remoteAccess';
import IBTable from '@totem/components/ui_components/antDesignOverrides/IBTable';
import TagDisplay, {
  OVERLAY_NETWORK_STATUS,
} from '@totem/components/ui_components/widgets/tagDisplay/tagDisplay';
import { isNotNull } from '@totem/utilities/common';

type Props = {
  overlayNetworks: RemoteAccessOverlayNetwork[];
  toggleEnabled: (
    overlay: RemoteAccessOverlayNetwork,
    enabled: boolean,
  ) => void;
};

const OverlayNetworksTable = ({ overlayNetworks, toggleEnabled }: Props) => {
  const handleToggle = (
    record: RemoteAccessOverlayNetwork,
    enabled: boolean,
  ) => {
    const verb = enabled ? 'Enable' : 'Disable';

    Modal.confirm({
      content: `Are you sure you want to ${verb} the overlay network ${record.overlayNetwork.name.replace(/-t(?!.*-t)/, '')}?`,
      title: `${verb} this overlay network?`,
      cancelText: 'No',
      okText: `Yes, ${verb}`,
      okType: 'danger',
      onOk: () => toggleEnabled(record, enabled),
    });
  };

  const columns: ColumnProps<RemoteAccessOverlayNetwork>[] = [
    {
      title: 'Overlay Network',
      dataIndex: 'overlayNetwork.name',
      key: 'name',
      showSorterTooltip: true,
      sortDirections: ['ascend', 'descend'],
      render: (_, record: RemoteAccessOverlayNetwork) => (
        <div>{record.overlayNetwork.name.replace(/-t(?!.*-t)/, '')}</div>
      ),
    },
    {
      title: 'Overlay Network Status',
      dataIndex: 'overlayNetwork.status',
      key: 'status',
      showSorterTooltip: false,
      render: (_, record: RemoteAccessOverlayNetwork) => (
        <TagDisplay
          value={
            record.overlayNetwork.enabled
              ? 'Network Access Enabled'
              : 'Network Access Disabled'
          }
          config={OVERLAY_NETWORK_STATUS}
        />
      ),
    },
    {
      title: 'Toggle',
      dataIndex: 'overlayNetwork.enabled',
      key: 'enabled',
      showSorterTooltip: true,
      sortDirections: ['ascend', 'descend'],
      align: 'right',
      render: (_, record: RemoteAccessOverlayNetwork) => (
        <Switch
          checked={record.overlayNetwork.enabled}
          onChange={(enabled) => handleToggle(record, enabled)}
        />
      ),
    },
  ];

  return (
    <IBTable
      showSorterTooltip
      columns={columns}
      dataSource={isNotNull(overlayNetworks) ? overlayNetworks : []}
      loading={false}
      pagination={{
        showSizeChanger: true,
      }}
      rowKey="id"
    />
  );
};

export default OverlayNetworksTable;
